import { ref } from 'vue'

// 创建一个响应式的消息数组
const messages = ref([])

let messageIdCounter = 0 // 自增计数器
// 生成唯一ID
const generateUniqueId = () => {
  messageIdCounter++
  return messageIdCounter
}

// 添加消息到队列
const addMessage = (type, text, duration) => {
  const message = {
    id: generateUniqueId(), // 生成唯一的ID
    type,
    text: text,
    duration,
    color: '#000',
    background: '#fff',
    icon: 'clear',
    isFading: false // 添加动画状态标志
  }
  messages.value.push(message)
  // 设置消息自动消失
  setTimeout(() => {
    startFadeOut(message.id)
  }, duration)
}

// 开始淡出动画
const startFadeOut = (id) => {
  const message = messages.value.find((msg) => msg.id === id)
  if (message) {
    message.isFading = true
  }
}

// 消息函数封装
const message = {
  error: (text, duration = 3000) => {
    addMessage('error', text, duration)
  }
}

export { messages, message }
